export default __webpack_public_path__ + "static/ryan-rodriguez-b44031945c7461daea26069c4b8749b3.png";